<template>
   <div>
     <apexchart ref="myChart" width="100%" :height="this.height ? this.height : 320" type="donut" :options="chartOptions" :series="series"></apexchart>
   </div>
</template>

<script>
import Vue from 'vue';
import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)

export default {
    props:['categories', 'chartdata', 'height', 'legend', 'labels', 'colors'],
    data: function() {
      return {
        chartOptions: {
            chart: {
                id: 'donutchart',
                type: 'donut',
            },
            // colors: this.colors ? this.colors : ['#7041e5', '#c8c8c8'],
            legend: {
                show: this.legend ? this.legend : false,
            },
            dataLabels: {
                enabled: this.labels ? this.labels : false
            },
            colors: ["#0cbcf2", "#003565", "#7041e5", "#b8c3d0", "#beaeff"]
        },
        series: this.chartdata,
      }
    },
    watch: {
        categories: (newVal, oldVal) => {
            // this.$nextTick(() => {
            //     this.$refs.myChart.refresh();
            // });
        },
        series: (newVal, oldVal) => {
            // this.$nextTick(() => {
            //     this.$refs.myChart.refresh();
            // });
        }
    }
};
</script>